// ===========================================
// Visibility Chip Component
// ===========================================

import { Chip } from '@mui/material';
import { Visibility as VisibilityIcon } from '@mui/icons-material';

interface Props {
  visibility: 'PARENTS' | 'STUDENTS' | 'TEACHERS_ONLY';
}

/**
 * Visibility chip helper - uses same colors as teacher notes
 */
export default function VisibilityChip({ visibility }: Props) {
  const isForStudent = visibility === 'STUDENTS';
  return (
    <Chip
      icon={<VisibilityIcon sx={{ fontSize: 14 }} />}
      label={isForStudent ? 'Student' : 'Parent'}
      size="small"
      color={isForStudent ? 'success' : 'warning'}
      sx={{
        height: 20,
        '& .MuiChip-label': { px: 0.75, fontSize: '0.65rem' },
      }}
    />
  );
}
